import { TokenService } from '../tokenService';

/**
 * Lê o accessToken efetivo — a MESMA resolução usada pelo api() (api.ts getRequestConfig):
 * sessionStorage primeiro (fonte prática no fluxo embarcado), TokenManager como fallback.
 * Não usar apenas TokenService: o mirror pode congelar em null no cold-start
 * (lazyLoad único em tokenMirror.ts) enquanto o storage já tem o token.
 */
export function readEffectiveAccessToken(): string | null {
  try {
    return (
      sessionStorage.getItem('cdr:auth:accessToken') ||
      sessionStorage.getItem('accessToken') ||
      TokenService.getAccessToken()
    );
  } catch {
    return TokenService.getAccessToken();
  }
}

/**
 * Aguarda o accessToken da sessão estar disponível (cold-start da sessão embarcada).
 *
 * Estratégia dupla: escuta `auth:updated` E faz polling do storage (quem grava o token
 * no fluxo embarcado pode escrever direto no sessionStorage sem disparar o evento).
 * Resolve `true` assim que o token existir; `false` se estourar o timeout.
 */
export function waitForAuthReady(timeoutMs = 5000): Promise<boolean> {
  if (readEffectiveAccessToken()) {
    return Promise.resolve(true);
  }

  return new Promise<boolean>((resolve) => {
    let settled = false;

    const finish = (ready: boolean) => {
      if (settled) return;
      settled = true;
      window.removeEventListener('auth:updated', onAuthUpdated);
      clearInterval(poller);
      clearTimeout(timer);
      resolve(ready);
    };

    const check = () => {
      if (readEffectiveAccessToken()) {
        finish(true);
      }
    };

    const onAuthUpdated = () => check();

    const poller = setInterval(check, 250);
    const timer = setTimeout(() => finish(!!readEffectiveAccessToken()), timeoutMs);
    window.addEventListener('auth:updated', onAuthUpdated);
  });
}
